export class FuncAppUrls{
  public static CpscUrl = 'https://vzn-eastus2-dataexchangeplatform-dev-fnapp-01.vzn-eastus2-extase-dev01-ase-01.appserviceenvironment.net/api/Function1?code=-YYycyQaY0KJPkOnfD7obvppPkKM4jArkG9REcYJvP5fAzFuvJy2UQ=='
};
